import * as _ from "lodash";
import React, { useEffect, useState } from "react";
import {
    getDataGridContent,
    mapAttributeListToSparePartList,
} from "../../../Helpers/sparePartTable";
import * as Models from "../../../Models";
import ExpandableDataGrid from "../DataGrid/ExpandableDataGrid";

interface ISparePartItemGroupOwnProps {
    dataGroupName: string;
    attributeMap: Models.AttributeMetadata[];
    attributeGroup: Models.AttributeGroup;
    changeRequests: Models.ChangeRequest[];
    match: Models.Match;
    setDirty: (value: boolean) => void;
}

export default function SparePartItemGroup(props: ISparePartItemGroupOwnProps) {
    const [showNonSpares, setShowNonSpares] = useState<boolean>(true);

    let existingParts: Models.SparePart[] = mapAttributeListToSparePartList(
        props.attributeGroup.rows
    );

    useEffect(() => {
        const existingSpareParts = _.filter(
            existingParts,
            (r) => r.isSparePart && r.isSparePart.toLocaleLowerCase() === "yes"
        );
        if (existingSpareParts?.length == 0 && existingParts?.length > 0)
            setShowNonSpares(true);
        else setShowNonSpares(false);
    }, [props?.attributeGroup?.rows]);

    if (!showNonSpares) {
        existingParts = _.filter(
            existingParts,
            (r) => r.isSparePart && r.isSparePart.toLocaleLowerCase() === "yes"
        );
    }

    let dataGridContent: Models.DataGridContent = null;

    dataGridContent = getDataGridContent(
        props.attributeGroup.headers,
        existingParts,
        props.changeRequests
    );

    const header: JSX.Element = (
        <div>
            <span>{props.attributeGroup.name}</span>
        </div>
    );

    return (
        <div className="ItemGroup ItemGroup--spareParts">
            <h3 className="ItemGroup__title">{header}</h3>

            <ExpandableDataGrid
                filterable={existingParts.length > 10}
                isSortable={existingParts.length > 10}
                showPagination={existingParts.length > 10}
                defaultPageSize={10}
                content={dataGridContent}
                addSpareParts={false}
                // subComponent={this.getEditableSubComponent(this.props)}
            />

            <button
                className="btn btn-primary mt-3 float-end"
                onClick={() => setShowNonSpares(!showNonSpares)}
            >
                {showNonSpares ? "Show only spare parts" : "Show all sboms"}
            </button>
        </div>
    );
}

// private getEditableSubComponent(
//     props: ISparePartItemGroupProps
// ): (row: any) => JSX.Element {
//     return (row: any) => {
//         const {
//             attributeGroup,
//             dataGroupName,
//             isEditMode,
//             editedSpareParts,
//             attributeMap,
//             changeRequests,
//         } = props;
//         const part: Models.ItemsApiSparePart =
//             row.original as Models.ItemsApiSparePart;
//         return (
//             <EditableSparePartItemGroup
//                 key={attributeGroup.name}
//                 dataGroupName={dataGroupName}
//                 isEditMode={isEditMode}
//                 isEditable={true}
//                 editedItemFields={editedSpareParts[part.itemNumber] || []}
//                 attributeMap={attributeMap}
//                 isCustomerDetail={false}
//                 isInstalledBaseSection={false}
//                 onChangeFieldValue={this.getChangeFieldValueHandler(
//                     part.itemNumber
//                 )}
//                 attributeGroup={this.mapAttributeGroup(
//                     part,
//                     attributeGroup.headers
//                 )}
//                 changeRequests={changeRequests}
//                 partNumber={part.itemNumber}
//                 match={props.match}
//             />
//         );
//     };
// }

// private getChangeFieldValueHandler(
//     itemNumber: string
// ): (editableField: Models.EditableItemField) => void {
//     return (editableField: Models.EditableItemField) => {
//         this.props.setDirty(true);
//         this.props.editSparePart(itemNumber, editableField);
//     };
// }

// private mapAttributeGroup(
//     sparePart: Models.ItemsApiSparePart,
//     headers: string[]
// ): Models.AttributeGroup {
//     const attributeGroup: Models.AttributeGroup = {
//         name: this.props.attributeGroup.name,
//         headers: ["Property", "Value"],
//         rows: Object.keys(sparePart).map((key, i) => {
//             return {
//                 items: [
//                     {
//                         url: null,
//                         description: headers[i],
//                         toolTip: null,
//                     },
//                     {
//                         url: null,
//                         description: sparePart[key].toString(),
//                         toolTip: null,
//                     },
//                 ],
//             };
//         }),
//     };
//     return attributeGroup;
// }
// }
